module.exports = {
	"aFile": "un fichier",
	"aFile_plural": "des fichiers",
	"clickToClearError": "Cliquez <a>ici</a> pour masquer $t(upload::demonstrateError).",
	"demonstrateError": "cette erreur",
	"demonstrateError_plural": "ces erreurs",
	"dropMessage": "Déposez $t(upload::aFile) ici ou cliquez sur le bouton pour sélectionner $t(upload::aFile) à envoyer.",
	"errors": {
		"size": "Le fichier est trop volumineux. La limite est de __limit__.",
		"type": "Le format du fichier est invalide, il doit s'agir d'un JPEG ou d'un PNG.",
		"quantity": "Vous avez dépassé votre limite de fichiers.",
		"unknown": "Cause inconnue"
	},
	"fileError": "Le fichier ci-dessous est responsable d'une erreur.",
	"fileError_plural": "Les fichiers ci-dessous sont responsables d'erreurs.",
	"pictureLimit": "Limite de photos",
	"progressMessage": "Progrès de l'envoi",
	"reorderMessage": "Vous pouvez glisser et déposer les photos pour les réordonner. La première sera utilisée comme miniature dans les listes.",
	"status": {
		"done": "Envoi terminé",
		"error": "Erreur d'envoi",
		"ongoing": "Envoi en cours",
		"pending": "En attente d'envoi"
	},
	"unsavedChanges": "Vos changements n'ont pas encore été enregistrés, vous devez soumettre le formulaire.",
	"uploadButton": "Envoyer"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/upload.json5
// module id = 2014
// module chunks = 6